import { fail } from "assert";

export type ValidatorFn = (
  value: any, 
  lookupValues?: { [key: string]: string[] }
) => { valid: boolean; message?: string };

// Map each field to its corresponding validation function.
export const ValidatorsMap: Record<string, ValidatorFn> = {
  // PropertyTypeAndTenancy validations
  'propertyTypeAndTenancy.propertyType': validatePropertyType,
  'propertyTypeAndTenancy.tenancy': validateTenancy,
  
  // SubjectPropertyLocation validations
  'subjectPropertyLocation.propertyName': validateTextMaxLength500,
  'subjectPropertyLocation.addressLine1': validateRequiredTextMaxLength500,
  'subjectPropertyLocation.country': validateCountry,
  'subjectPropertyLocation.city': validateCity,
  'subjectPropertyLocation.state': validateState,
  'subjectPropertyLocation.zipCode': validateZipCode,
  'subjectPropertyLocation.latitude': validateLatitude,
  'subjectPropertyLocation.longitude': validateLongitude,
  //'subjectPropertyLocation.county': validateCounty,

  // ExternalReferenceId validation
  'externalReferenceId': validateTextMaxLength50,

  'siteInformation.groundLeases': validateYesNo,
  'siteInformation.groundLeaseDescription': validateGroundLeasesDescription,
  'siteInformation.primaryLandMeasure': validateLandAreaMeasure,
  'siteInformation.primaryLandValue': validateNumber,
  'siteInformation.primaryLandExcess': validateNumber,
  'siteInformation.secondaryLandMeasure': validateLandAreaMeasure,
  'siteInformation.secondaryLandValue': validateNumber,
  'siteInformation.secondaryLandExcess': validateNumber,
  'siteInformation.topography': validateTopography,

  'siteInformation.electric.paidBy': validateUtilityPaidBy,
  'siteInformation.gas.paidBy': validateUtilityPaidBy,
  'siteInformation.refuse.paidBy': validateUtilityPaidBy,
  'siteInformation.water.paidBy': validateUtilityPaidBy,
  'siteInformation.sewer.paidBy': validateUtilityPaidBy,
  'siteInformation.telephone.paidBy': validateUtilityPaidBy,

  // Ownership
  'ownership.soldInLastThreeYears': validateYesNo,
  'ownership.saleDate': validateDateByFormatMMDDYYYY,
  'ownership.salePrice': validateCurrency,
  'ownership.listPrice': validateCurrency,
  'ownership.contractPrice': validateCurrency,
  
  'floodZoneInformation.floodZone': validateFloodZone,

  // ImprovementInformation validations
  'improvementInformation.yearBuilt': validateYear,
  'improvementInformation.primaryImprovementMeasure': validateImprovementMeasure,
  'improvementInformation.primaryImprovementValue': validateNumber,
  'improvementInformation.primaryImprovementPriorValue': validateNumber,
  'improvementInformation.secondaryImprovementMeasure': validateImprovementMeasure,
  'improvementInformation.secondaryImprovementValue': validateNumber,
  'improvementInformation.secondaryImprovementPriorValue': validateNumber,
  'improvementInformation.tertiaryImprovementMeasure': validateImprovementMeasure,
  'improvementInformation.tertiaryImprovementValue': validateNumber,
  'improvementInformation.tertiaryImprovementPriorValue': validateNumber,
  'improvementInformation.occupancy': validatePercentage,
  'improvementInformation.vacancy': validatePercentage,
  'improvementInformation.yearRenovated': validateYear,
  'improvementInformation.numberOfBuildings': validateWholeNumber,
  'improvementInformation.numberOfStories': validateWholeNumber,
  'improvementInformation.effectiveAge': validateWholeNumber,
  'improvementInformation.economicLife': validateWholeNumber, 

  // ImprovementInformation Industrial validations
  'improvementInformationIndustrial.percentOfficeSpace': validatePercentage,
  
  // ImprovementInformation Living validations
  'improvementInformationLiving.landOwnershipInterest': validateLandOwnershipInterest,

  'mechanicalDetails.hvac': validateHVACType,
  'mechanicalDetails.numberofPassengerElevators': validateNumber,
  'mechanicalDetails.numberofFreightElevators': validateNumber, 

  'taxes.totalPropertyTaxes' : validateCurrency,
  'taxes.equalizationRate': validatePercentageWithoutRange,
  'taxes.totalTaxRate': validatePercentageWithoutRange,
  'taxes.currentTaxYear': validateYear,
  'taxes.assessmentRatio' : validatePercentageLoose,
  'taxes.percentDiscountIfTaxBillPaidByDecember' : validatePercentageLoose,
  'taxes.totalTaxExemptions': validateCurrency,
  'taxes.totalAssessedValue': validateCurrency,
  'taxes.improvementsAssessedValue': validateCurrency,
  'taxes.landAssessedValue': validateCurrency,
  'taxes.assessorsMarketValue': validateCurrency,

  //construction costs
  'constructionCosts.softCosts': validateCurrency,
  'constructionCosts.furnitureFixturesandEquipment': validateCurrency,
  'constructionCosts.siteImprovementCost': validateCurrency,
  'constructionCosts.buildingImprovementCosts': validateCurrency,
  'constructionCosts.totalEntrepreneurialProfit': validateCurrency,
  
  // Valuations
  'valuations.dateOfInspection' : validateDateByFormatMMDDYYYY,
  'valuations.dateOfReport' : validateDateByFormatMMDDYYYY,
  'valuations.currency' : validateCurrencyOptions,

  // Cashflow validations
  'cashflow.walt': validateCashflowWalt,
  'cashflow.vacancy': validatePercentage,
  'cashflow.downtime': validateNumber,
  'cashflow.year1NOIPSF': validateCurrency,
  'cashflow.concessions': validateCurrency,
  'cashflow.priorConcessions': validateCurrency,
  'cashflow.collectionLoss': validatePercentage,
  'cashflow.priorCollectionLoss': validatePercentage,
  'cashflow.netOperationIncome.year1': validateCurrency,
  'cashflow.netOperationIncome.year2': validateCurrency,
  'cashflow.netOperationIncome.year3': validateCurrency,
  'cashflow.netOperationIncome.year4': validateCurrency,
  'cashflow.netOperationIncome.year5': validateCurrency,
  'cashflow.netOperationIncome.year6': validateCurrency,
  'cashflow.netOperationIncome.year7': validateCurrency,
  'cashflow.netOperationIncome.year8': validateCurrency,
  'cashflow.netOperationIncome.year9': validateCurrency,
  'cashflow.netOperationIncome.year10': validateCurrency,
  'cashflow.netOperationIncome.year11': validateCurrency,
  'cashflow.impliedOverallRate.year1': validatePercentage,
  'cashflow.impliedOverallRate.year2': validatePercentage,
  'cashflow.impliedOverallRate.year3': validatePercentage,
  'cashflow.impliedOverallRate.year4': validatePercentage,
  'cashflow.impliedOverallRate.year5': validatePercentage,
  'cashflow.impliedOverallRate.year6': validatePercentage,
  'cashflow.impliedOverallRate.year7': validatePercentage,
  'cashflow.impliedOverallRate.year8': validatePercentage,
  'cashflow.impliedOverallRate.year9': validatePercentage,
  'cashflow.impliedOverallRate.year10': validatePercentage,
  'cashflow.impliedOverallRate.year11': validatePercentage,
  'cashflow.realEstateTaxGrowthRate': validatePercentageWithoutRange, 
  'cashflow.netCashFlowAmount': validateCurrency, 

  'cashflowLiving.nonApartmentTotalPSF': validateNotRequiredIntegers,
  'cashflowRetail.rollingTwelveMonthsSalesPSF': validateCurrency,

  // TenantInformation validations
  'tenantInformation.largestTenant': validateTextMaxLength250,
  'tenantInformation.largestTenantArea': validateLargestTenantArea,
  'tenantInformation.largestTenantAreaPercent': validatePercentage,
  'tenantInformation.leaseExpires': validateDateByFormatMMDDYYYY,
  'tenantInformation.numberOfTenants': validateWholeNumber,

  'assumptions.marketInflationYears1_5':validatePercentageWithoutRange,
  'assumptions.expenseInflationYears1_5':validatePercentageWithoutRange,

  'leaseExpirations.fiveYearCumulativeExpirationsPSF':validatePercentage,

  'valuations.clientOwnership':validatePercentage,

  'leasingAssumptions.leaseType' : validateLeaseType,
  'leasingAssumptions.marketLeaseTerm' : validateMarketLeaseTerm,
  'leasingAssumptions.marketLeasingTenantImprovementsNewLeases' : validateCurrency,
  'leasingAssumptions.year1TenantImprovements' : validateCurrency,
  'leasingAssumptions.year1LeasingCommissions' : validateCurrency,
  'leasingAssumptions.marketLeasingCommissionsNewLeases' : validatePercentage,
  'leasingAssumptions.expenseReimbursement' : validateCurrency,
  'leasingAssumptions.renewalProbability' : validatePercentage,

  'contractMonthRent.averageContractRentPSF' : validatePositiveHundredKCurrencyIncludeZero,
  'contractMonthRent.annualContractRentTotal' : validateCurrency,
  'contractMonthRent.averageMarketRentPSF' : validateCurrency,
  'contractMonthRent.annualMarketRentTotal' : validateCurrency,
  'contractMonthRent.crmr' : validatePercentage,
  'contractMonthRent.marketOccupancyPercent': validatePercentage,

  'valuationSummary.asIsScenario.dateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.asIsScenario.priorDateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.asIsScenario.landValue': validateCurrency,
  'valuationSummary.asIsScenario.excessLandValue': validateCurrency,
  'valuationSummary.asIsScenario.insurableReplacementCost': validateCurrency,
  'valuationSummary.asIsScenario.costApproachIndicatedValue': validateCurrency,
  'valuationSummary.asIsScenario.totalDepreciation': validateCurrency,  
  'valuationSummary.asIsScenario.salesComparisonApproachIndicatedValue': validateCurrency,
  'valuationSummary.asIsScenario.incomeCapitalizationApproach': validateCurrency,
  'valuationSummary.asIsScenario.directCapitalizationIndicatedValue': validateCurrency,
  'valuationSummary.asIsScenario.finalValue': validateCurrency,
  'valuationSummary.asIsScenario.priorFinalValue': validateCurrency,
  'valuationSummary.asIsScenario.primaryValue': validateCurrency,
  'valuationSummary.asIsScenario.terminalCapitalizationRate': validatePercentage,  

  'valuationSummary.asIsScenario.priorTerminalCapitalizationRate': validatePercentage,
  'valuationSummary.asIsScenario.internalRateOfReturn': validatePercentageWithoutRange,
  'valuationSummary.asIsScenario.priorInternalRateOfReturn': validatePercentageWithoutRange,
  'valuationSummary.asIsScenario.capitalizationRate': validatePercentage,
  'valuationSummary.asIsScenario.priorCapitalizationRate': validatePercentage,
  'valuationSummary.asIsScenario.exposurePeriod': validatePeriod,
  'valuationSummary.asIsScenario.marketingPeriod': validatePeriod,
  'valuationSummary.asIsScenario.yieldCapitalizationIndicatedValue': validateCurrency,

  'valuationSummary.uponCompletionScenario.dateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.uponCompletionScenario.priorDateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.uponCompletionScenario.landValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.excessLandValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.insurableReplacementCost': validateCurrency,  
  'valuationSummary.uponCompletionScenario.costApproachIndicatedValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.totalDepreciation': validateCurrency,
  'valuationSummary.uponCompletionScenario.salesComparisonApproachIndicatedValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.incomeCapitalizationApproach': validateCurrency,
  'valuationSummary.uponCompletionScenario.directCapitalizationIndicatedValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.finalValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.priorFinalValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.primaryValue': validateCurrency,
  'valuationSummary.uponCompletionScenario.terminalCapitalizationRate': validatePercentage,
  'valuationSummary.uponCompletionScenario.priorTerminalCapitalizationRate': validatePercentage,
  'valuationSummary.uponCompletionScenario.internalRateOfReturn': validatePercentage,
  'valuationSummary.uponCompletionScenario.priorInternalRateOfReturn': validatePercentageWithoutRange,
  'valuationSummary.uponCompletionScenario.capitalizationRate': validatePercentage,
  'valuationSummary.uponCompletionScenario.priorCapitalizationRate': validatePercentage,
  'valuationSummary.uponCompletionScenario.yieldCapitalizationIndicatedValue': validateCurrency,

  'valuationSummary.uponStabilizationScenario.dateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.uponStabilizationScenario.priorDateOfValue': validateDateByFormatMMDDYYYY,
  'valuationSummary.uponStabilizationScenario.landValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.excessLandValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.insurableReplacementCost': validateCurrency,
  'valuationSummary.uponStabilizationScenario.costApproachIndicatedValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.totalDepreciation': validateCurrency,
  'valuationSummary.uponStabilizationScenario.salesComparisonApproachIndicatedValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.incomeCapitalizationApproach': validateCurrency,
  'valuationSummary.uponStabilizationScenario.directCapitalizationIndicatedValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.finalValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.priorFinalValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.primaryValue': validateCurrency,
  'valuationSummary.uponStabilizationScenario.terminalCapitalizationRate': validatePercentage,
  'valuationSummary.uponStabilizationScenario.priorTerminalCapitalizationRate': validatePercentage,
  'valuationSummary.uponStabilizationScenario.internalRateOfReturn': validatePercentage,
  'valuationSummary.uponStabilizationScenario.priorInternalRateOfReturn': validatePercentage,
  'valuationSummary.uponStabilizationScenario.capitalizationRate': validatePercentageWithoutRange,
  'valuationSummary.uponStabilizationScenario.priorCapitalizationRate': validatePercentage,
  'valuationSummary.uponStabilizationScenario.yieldCapitalizationIndicatedValue': validateCurrency,

  'revenueAndExpense.yearOne.baseRentalRevenue': validateCurrency,
  'revenueAndExpense.yearOne.totalOtherIncome': validateCurrency,
  'revenueAndExpense.yearOne.potentialGrossRevenue': validateCurrency,
  'revenueAndExpense.yearOne.vacancyandCollectionLoss': validateCurrency,
  'revenueAndExpense.yearOne.effectiveGrossRevenue': validateCurrency,
  'revenueAndExpense.yearOne.groundRent': validateCurrency,
  'revenueAndExpense.yearOne.totalExpenses': validateCurrency,
  'revenueAndExpense.yearOne.noiTotalAmount': validateCurrency,
  'revenueAndExpense.yearOne.operatingExpenses': validateCurrency,
  'revenueAndExpense.yearOne.generalnAdministrative': validateCurrency,
  'revenueAndExpense.yearOne.insurance': validateCurrency,
  'revenueAndExpense.yearOne.managementFees': validateCurrency,
  'revenueAndExpense.yearOne.realEstateTaxes': validateCurrency,
  'revenueAndExpense.yearOne.replacementReserves': validateCurrency,

  'revenueAndExpense.stabilizedYear.baseRentalRevenue': validateCurrency,
  'revenueAndExpense.stabilizedYear.totalOtherIncome': validateCurrency,
  'revenueAndExpense.stabilizedYear.potentialGrossRevenue': validateCurrency,
  'revenueAndExpense.stabilizedYear.vacancyandCollectionLoss': validateCurrency,
  'revenueAndExpense.stabilizedYear.effectiveGrossRevenue': validateCurrency,
  'revenueAndExpense.stabilizedYear.groundRent': validateCurrency,
  'revenueAndExpense.stabilizedYear.totalExpenses': validateCurrency,
  'revenueAndExpense.stabilizedYear.noiTotalAmount': validateCurrency,
  'revenueAndExpense.stabilizedYear.operatingExpenses': validateCurrency,
  'revenueAndExpense.stabilizedYear.generalnAdministrative': validateCurrency,
  'revenueAndExpense.stabilizedYear.insurance': validateCurrency,
  'revenueAndExpense.stabilizedYear.managementFees': validateCurrency,
  'revenueAndExpense.stabilizedYear.realEstateTaxes': validateCurrency,
  'revenueAndExpense.stabilizedYear.replacementReserves': validateCurrency,

  // Existing validations you already have
  // ...other existing validators...
};

/* --------- Synchronous Validator Functions --------- */
//accepted: "99,999", "1,57,055", "99999", "-2,000", "+12"
//rejected: "1,23", "1,234,", "1,234.56", "12 345"
export function validateWholeNumber(value: any): { valid: boolean; message?: string } {
  // Treat null/undefined/empty-string as "no value" (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
 const err = { valid: false, message: "Please enter a whole number in the format '100'." };
  // If it's already a number, ensure it's a finite integer
  if (typeof value === 'number') {
    return Number.isFinite(value) && Number.isInteger(value)
      ? { valid: true }
      : err;
  }

  if (typeof value !== 'string') {
    return err;
  }

  const trimmed = value.trim();

  // US: 1,234,567 or 1234567
  const us = /^[+-]?(?:\d{1,3}(?:,\d{3})+|\d+)$/;

  // Indian: 12,34,56,789 or 1,57,055
  const indian = /^[+-]?(?:\d{1,3}|(?:\d{1,2}(?:,\d{2})+,\d{3}))$/;

  if (!(us.test(trimmed) || indian.test(trimmed))) {
    return err;
  }

  // Remove commas and verify integer parse
  const normalized = trimmed.replace(/,/g, '');
  const num = Number(normalized);

  if (!Number.isFinite(num) || !Number.isInteger(num)) {
    return { valid: false, message: 'Only whole numbers allowed.' };
  }

  return { valid: true };
}

//accepted: "99,999", "1,234,567.89", "99999", "-2,000", "+12.5"
//rejected: "1,23", "1,234,", "1,234.56.7", "12 345"
export function validateNumber(value: any): { valid: boolean; message?: string } {
  // Treat null/undefined/empty-string as “no value” (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  const err = { valid: false, message: "Please enter a whole number in the format '1,000' (comma if value exceeds hundreds)." };
  // If it's already a number, ensure it's finite
  if (typeof value === 'number') {
    return Number.isFinite(value)
      ? { valid: true }
      : err;
  }

  if (typeof value !== 'string') {
    return err;
  }

  const trimmed = value.trim();

  // US: 1,234,567.89 or 1234567.89
  const us = /^[+-]?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?$/;

  // Indian: 12,34,56,789.00 or 1,57,055
  //   - first group 1–3 digits
  //   - then one or more ",\d{2}" groups
  //   - ends with ",\d{3}"
  const indian = /^[+-]?(?:\d{1,3}|(?:\d{1,2}(?:,\d{2})+,\d{3}))(?:\.\d+)?$/;

  if (!(us.test(trimmed) || indian.test(trimmed))) {
    return err;
  }

  // Remove commas and verify it parses
  const normalized = trimmed.replace(/,/g, '');
  const num = Number(normalized);

  if (!Number.isFinite(num)) {
    return { valid: false, message: 'Only numeric values allowed.' };
  }

  return { valid: true };
}

function validateRequiredTextMaxLength500(value: any): { valid: boolean; message?: string } {
  const valuePresence = requiredValidation(value);
  if (!valuePresence.valid) { return valuePresence; }

  return validateTextMaxLength500(value);
}

function validateTextMaxLength500(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string')
    return { valid: false, message: 'Only text values allowed.' };
  return value.length <= 500
    ? { valid: true }
    : { valid: false, message: 'Maximum 500 characters allowed.' };
}

function validateTextMaxLength50(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string')
    return { valid: false, message: 'Only text values allowed.' };
  return value.length <= 50
    ? { valid: true }
    : { valid: false, message: 'External Reference Id exceeds 50 characters.' };
}

function validateTextMaxLength250(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string')
    return { valid: false, message: 'Only text values allowed.' };
  return value.length <= 250
    ? { valid: true }
    : { valid: false, message: 'Largest Tenants field must not exceed 250 characters.' };
}

// function validateYear(value: any): { valid: boolean; message?: string } {
//   if ((typeof value === 'string' && value.length !==0 && (value.length !== 4 || !/^\d{4}$/.test(value)))) {
//     return { valid: false, message: 'Year is invalid.' };
//   }
//   return { valid: true };
// }

function validateNullableYear(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value === 'string' && (value.trim() === 'N/A' || value.trim() === 'NA' )){
    return { valid: true };
  }

  if (typeof value !== 'string' || value.trim().length !== 4 || !/^\d{4}$/.test(value.trim())) {
    return { valid: false, message: 'Year is invalid.' };
  }

  return { valid: true };
}

export function validateUtilityPaidBy(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const allowed = lookupValues ? lookupValues['UtilityPaidBy'] || [] : [];
  const lowerValue = value.toString().toLowerCase();
  const isValid = allowed.some(item => item.toString().toLowerCase() === lowerValue);
  return isValid
    ? { valid: true }
    : { valid: false, message: 'Please refer to your Excel workbook and select one of the predefined values.' };
}

export function validateLandOwnershipInterest(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const allowed = lookupValues ? lookupValues['LandOwnershipInterest'] || [] : [];
  const lowerValue = value.toString().toLowerCase();
  const isValid = allowed.some(item => item.toString().toLowerCase() === lowerValue);
  return isValid
    ? { valid: true }
    : { valid: false, message: 'Please refer to your Excel workbook and select one of the predefined values.' };
}

export function validateHVACType(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const allowed = lookupValues ? lookupValues['HVACType'] || [] : [];
  const lowerValue = value.toString().toLowerCase();
  const isValid = allowed.some(item => item.toString().toLowerCase() === lowerValue);
  return isValid
    ? { valid: true }
    : { valid: false, message: 'Please refer to your Excel workbook and select one of the predefined values.' };
}

export function validateImprovementMeasure(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const allowed = lookupValues ? lookupValues['AreaMeasureName'] || [] : [];
  const lowerValue = value.toString().toLowerCase();
  const isValid = allowed.some(item => item.toString().toLowerCase() === lowerValue);
  return isValid
    ? { valid: true }
    : { valid: false, message: 'Please refer to your Excel workbook and select one of the predefined values.' };
}

function validateLandAreaMeasure(value: any): { valid: boolean; message?: string } {
  const allowedLandAreaMeasureValues = ['Gross Land Area', 'Net Land Area'];
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  return allowedLandAreaMeasureValues.includes(value)
    ? { valid: true }
    : {
        valid: false,
        message:
          'Please refer to your Excel workbook and select one of the predefined values.',
      };
}

function validateTopography(value: any): { valid: boolean; message?: string } {
  const allowedTopographyValues = ['Level', 'Level at street grade', 'Gently sloping', 'Hilly', 'Rolling', 'Steep', 'Rough'];
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  return allowedTopographyValues.includes(value)
    ? { valid: true }
    : {
        valid: false,
        message:
          'Please refer to your Excel workbook and select one of the predefined values.',
      };
}

function validateFloodZone(value: any): { valid: boolean; message?: string } {
  const allowedFloodZoneValues = ['A', 'AE', 'AH', 'AO', 'A11', 'A99', 'B', 'C', 'D', 'V', 'VE', 'X', 'X500L', 'X500'];
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  return allowedFloodZoneValues.includes(value)
    ? { valid: true }
    : {
        valid: false,
        message:
          'Please refer to your Excel workbook and select one of the predefined values.',
      };
}

function validateCurrencyOptions(value: any): { valid: boolean; message?: string } {
  const allowedCurrencyValues = ['USD', 'CAD', 'TBD']; // Example currency values
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  return allowedCurrencyValues.includes(value)
    ? { valid: true }
    : {
        valid: false,
        message:
          'Please refer to your Excel workbook and select one of the predefined values.',
      };
}

function validateOccupancyLength(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string')
    return { valid: false, message: 'Occupancy must be text.' };
  return value.length <= 15
    ? { valid: true }
    : { valid: false, message: 'Occupancy is invalid.' };
}

function validatePropertyType(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  // Allowed property types are fetched via the LookupService.
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: false, message: 'This is required field.' };
  }
  const allowed = lookupValues ? lookupValues['PropertyType'] || [] : [];
  return allowed.includes(value)
    ? { valid: true }
    : { valid: false, message: 'Property Type is invalid.' };
}

function validateTenancy(value: any): { valid: boolean; message?: string } {
  const allowedTenancyValues = ['Owner-Occupied', 'Single-Tenant', 'Multi-Tenant'];
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  return allowedTenancyValues.includes(value)
    ? { valid: true }
    : {
        valid: false,
        message:
          'Please enter one of the allowable values: Owner-Occupied, Single-Tenant, Multi-Tenant.',
      };
}

/**
 * Truncates a number to at most two decimal places
 */
function truncateTwoDecimals(n: number): number {
  return Math.trunc(n * 100) / 100;
}

export function validateCashflowWalt(value: any): { valid: boolean; message?: string; cleaned?: number } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  // Convert to string, enforce max total length
  let str = String(value);
  if (str.length > 10) {
    return {
      valid: false,
      message: 'WALT must not exceed 10 characters in length.',
    };
  }

  // Allow only digits and at most one dot
  if (!/^\d+(\.\d*)?$/.test(str)) {
    return { valid: false, message: 'WALT must be a valid decimal number.' };
  }

  // --- HERE’S THE KEY PART: truncate, don’t round ---
  const numUntruncated = parseFloat(str);
  const num = truncateTwoDecimals(numUntruncated);

  // Check range
  if (num < 0.0 || num > 1000.0) {
    return {
      valid: false,
      message: 'WALT must be between 0.00 and 1000.00.',
    };
  }

  // If user typed more than two decimals, `num` will be lower:
  //    36.58999  → numUntruncated = 36.58999  → num = 36.58
  //    36.58     → numUntruncated = 36.58     → num = 36.58
  // You can return the cleaned-up value if you want to overwrite the input:
  return { valid: true, cleaned: num };
}

function validateLargestTenantArea(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string') value = String(value);
  const sanitized = value.replace(/,/g, '');
  const num = parseFloat(sanitized);
  if (isNaN(num)) {
    return {
      valid: false,
      message: 'Please enter valid integer(s).',
    };
  }  
  return { valid: true };
}

// The following lookup-based validators use the provided lookupValues object.
function validateCountry(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {

  const valuePresence = requiredValidation(value);
  if (!valuePresence.valid) { return valuePresence; }

  // ensure we're working with a string and strip off trailing spaces
  const candidate =
    typeof value === 'string' ? value.trim() : String(value);

  const allowed = lookupValues?.['CountryName'] ?? [];

  return allowed.includes(candidate)
    ? { valid: true }
    : { valid: false, message: 'Country is invalid.' };
}

function validateCity(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  const valuePresence = requiredValidation(value);
  if (!valuePresence.valid) { return valuePresence; }
  
  const allowed = lookupValues ? lookupValues['CityName'] || [] : [];
  return allowed.includes(value)
    ? { valid: true }
    : { valid: false, message: 'City is invalid.' };
}

function validateState(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {

  const valuePresence = requiredValidation(value);
  if (!valuePresence.valid) { return valuePresence; }

  const allowed = lookupValues ? lookupValues['StateName'] || [] : [];
  return allowed.includes(value)
    ? { valid: true }
    : { valid: false, message: 'State is invalid.' };
}

export function validateZipCode(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {
  // empty is OK
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  // const str = String(value);

  // // new: must be exactly 5 characters
  // if (!/^\d{5}$/.test(str)) {
  //   return { valid: false, message: 'ZipCode must be 5 digits.' };
  // }

  // const allowed = lookupValues ? lookupValues['ZipCode'] || [] : [];

  // return allowed.includes(str)
  //   ? { valid: true }
  //   : { valid: false, message: 'ZipCode is invalid.' };

  return { valid: true };
}

// The following lookup-based validators use the provided lookupValues object.
function validateCounty(
  value: any,
  lookupValues?: { [key: string]: string[] }
): { valid: boolean; message?: string } {

  const valuePresence = requiredValidation(value);
  if (!valuePresence.valid) { return { valid: true }; }

  // ensure we're working with a string and strip off trailing spaces
  const candidate =
    typeof value === 'string' ? value.trim() : String(value);

  const allowed = lookupValues?.['CountyName'] ?? [];

  return allowed.includes(candidate)
    ? { valid: true }
    : { valid: false, message: 'Please enter a valid text string.' };
}

function validateYesNo(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }

  const normalized = value.trim().toLowerCase();

  if (normalized !== 'yes' && normalized !== 'no') {
    return { valid: false, message: 'Value must be either "yes" or "no".' };
  }

  return { valid: true };
}

function validateGroundLeasesDescription(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }

  if (value.length > 2000) {
    return { valid: false, message: 'Value must not exceed 2000 characters.' };
  }

  return { valid: true };
}


// function validateNumberOfTenants(value: any): { valid: boolean; message?: string } {
//   if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
//     return { valid: true };
//   }

//   if (typeof value !== 'number' && typeof value !== 'string') {
//     return { valid: false, message: 'Value must be a number or numeric string.' };
//   }

//   const strValue = String(value).trim();

//   if (!/^\d+$/.test(strValue)) {
//     return { valid: false, message: 'Value must be a valid number.' };
//   }

//   if (strValue.length > 4) {
//     return { valid: false, message: 'Value must not exceed 4 digits.' };
//   }

//   return { valid: true };
// }

function validateLeaseType(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }

  if (value.length > 25) {
    return { valid: false, message: 'Value must not exceed 25 characters.' };
  }

  return { valid: true };
}

function validateMarketLeaseTerm(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }

  if (value.length > 25) {
    return { valid: false, message: 'Value must not exceed 25 characters.' };
  }

  return { valid: true };
}

export function validateCurrency(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }
  if (!value.includes('$')) {
    return { valid: false, message: "Please enter a valid currency amount in the format '$100,000' (whole number, comma separator, '$' at the beginning)." };
  }
  
  const us =/^\s*(?:-\s*|\(\s*)?\$\s*(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?\s*(?:\))?\s*$/;

          // e.g., $447,510.25 or $12345
  const indian = /^\s*\$\s*(?:\d{1,3}|(?:\d{1,2}(?:,\d{2})+,\d{3}))(?:\.\d{1,2})?\s*$/; // e.g., $4,47,510 or $12,34,56,789.00

  if (!(us.test(value) || indian.test(value))) {
    return {
      valid: false,
      message: "Please enter a valid currency amount in the format '$100,000' (whole number, comma separator, '$' at the beginning)."
    };
  }

  return { valid: true };
}

export function validateNACurrency(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  if (typeof value !== 'string') {
    return { valid: false, message: 'Value must be a string.' };
  }

  const norm = value.trim().toLowerCase();
  if (norm === 'n/a' || norm === 'na') {
    return { valid: true };
  }

  if (!value.includes('$')) {
    return { valid: false, message: "Please enter a valid currency amount in the format '$100,000' (whole number, comma separator, '$' at the beginning)." };
  }

  const us = /^\s*\$\s*(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?\s*$/;                 // e.g., $447,510.25 or $12345
  const indian = /^\s*\$\s*(?:\d{1,3}|(?:\d{1,2}(?:,\d{2})+,\d{3}))(?:\.\d{1,2})?\s*$/; // e.g., $4,47,510 or $12,34,56,789.00

  if (!(us.test(value) || indian.test(value))) {
    return {
      valid: false,
      message: "Please enter a valid currency amount in the format '$100,000' (whole number, comma separator, '$' at the beginning)."
    };
  }

  return { valid: true };
}

export function validatePercentage(
  value: any,
  opts: { min?: number; max?: number; allowPercentSymbol?: boolean } = {}
): { valid: boolean; message?: string } {
  // treat null/undefined/empty-string as “no value” (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  const min = opts.min ?? 0;
  const max = opts.max ?? 100;
  const allowPercentSymbol = opts.allowPercentSymbol ?? true;

  // Helper for consistent error text
  const err = (m = "Please enter a percentage between 0 and 100 in the format '12.34%' (exactly two decimal places, '%' at the end)") =>
    ({ valid: false, message: m });

  // If already a number, validate numeric rules (2 dp + range)
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return err();
    // must be representable with exactly 2 decimals
    if (Math.round(value * 100) !== value * 100) {
      return err();
    }
    if (value < min || value > max) {
      return err();
    }
    // If exactly 100, decimals must be .00 (already true because it has exactly 2 dp numerically)
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return err();
  }

  let raw = value.trim();

  // If a % appears, it must be allowed and appear exactly once at the end
  const hasPercent = raw.includes('%');
  if (hasPercent) {
    if (!allowPercentSymbol) return err();
    if (!/^\s*[+-]?\d+(?:\.\d{2})\s*%\s*$/.test(raw)) {
      // exactly two decimals and % at end
      return err();
    }
    raw = raw.replace(/%/g, '').trim();
  } else {
    // No percent sign: still enforce exactly two decimals
    if (!/^\s*[+-]?\d+(?:\.\d{2})\s*$/.test(raw)) {
      return err();
    }
  }

  // Now parse and validate numeric
  const num = Number(raw);
  if (!Number.isFinite(num)) return err();

  if (num < min || num > max) {
    return err();
  }

  // If value is 100, decimals must be .00 (e.g., 100.00 or 100.00%)
  if (num === 100) {
    const requiresHundredOk = hasPercent
      ? /\b100\.00%\s*$/.test(value.trim())
      : /\b100\.00\s*$/.test(value.trim());
    if (!requiresHundredOk) return err();
  }

  return { valid: true };
}

//Accepts: "0", "100", "11.25", 0, 100, 11.25
//Rejects: "11.2", "11.250", "100.10", "12" (no %), "12%" (if allowPercentSymbol is false)
export function validatePercentageWithoutRange(
  value: any,
  opts: { allowPercentSymbol?: boolean } = {}
): { valid: boolean; message?: string } {
  // treat null/undefined/empty-string as “no value” (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  
  const allowPercentSymbol = opts.allowPercentSymbol ?? true;

  // Helper for consistent error text
  const err = (m = "Please enter a percentage in the format '12.34%' (exactly two decimal places, '%' at the end).") =>
    ({ valid: false, message: m });

  // If already a number, validate numeric rules (2 dp + range)
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return err();
    // must be representable with exactly 2 decimals
    if (Math.round(value * 100) !== value * 100) {
      return err();
    }
    
    // If exactly 100, decimals must be .00 (already true because it has exactly 2 dp numerically)
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return err();
  }

  let raw = value.trim();

  // If a % appears, it must be allowed and appear exactly once at the end
  const hasPercent = raw.includes('%');
  if (hasPercent) {
    if (!allowPercentSymbol) return err();
    if (!/^\s*[+-]?\d+(?:\.\d{2})\s*%\s*$/.test(raw)) {
      // exactly two decimals and % at end
      return err();
    }
    raw = raw.replace(/%/g, '').trim();
  } else {
    // No percent sign: still enforce exactly two decimals
    if (!/^\s*[+-]?\d+(?:\.\d{2})\s*$/.test(raw)) {
      return err();
    }
  }

  // Now parse and validate numeric
  const num = Number(raw);
  if (!Number.isFinite(num)) return err();

  // If value is 100, decimals must be .00 (e.g., 100.00 or 100.00%)
  if (num === 100) {
    const requiresHundredOk = hasPercent
      ? /\b100\.00%\s*$/.test(value.trim())
      : /\b100\.00\s*$/.test(value.trim());
    if (!requiresHundredOk) return err();
  }

  return { valid: true };
}

// Accepts: "0%", "100%", "11%", "11.25%", "0.00%", "100.00%"
// Rejects: 0, 100, 11.25 (numbers), "11.2%", "11.250%", "100.10%", "12" (no %)
export function validatePercentageLoose(
  value: any,
  opts: { min?: number; max?: number } = {}
): { valid: boolean; message?: string } {
  // treat null/undefined/empty-string as “no value” (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  const min = opts.min ?? 0;
  const max = opts.max ?? 100;

  const err = (m = "Please enter a percentage between 0 and 100 in the format '12%' ('%' at the end).") =>
    ({ valid: false, message: m });

  // Numbers are NOT allowed (must include %)
  if (typeof value === 'number') {
    return err();
  }

  if (typeof value !== 'string') return err();

  const s = value.trim();

  // Require exactly one trailing % and either integer or exactly two decimals
  // Examples: "12%", "12.34%", "0%", "0.00%", "100%", "100.00%"
  const m = s.match(/^\s*([+-]?\d+)(?:\.(\d{2}))?\s*%\s*$/);
  if (!m) return err();

  const intPart = m[1];
  const fracPart = m[2] ?? '';
  const num = Number(intPart + (fracPart ? '.' + fracPart : ''));

  if (!Number.isFinite(num)) return err();

  if (num < min || num > max) {
    return err();
  }

  // If value is 100 and decimals are present, they must be .00
  if (num === 100 && fracPart && fracPart !== '00') {
    return err();
  }

  return { valid: true };
}

export function validateYear(value: any): { valid: boolean; message?: string } {
  const error = { valid: false, message: "Please enter a valid year (YYYY)." };

  // Treat undefined/null/empty string as "no value" (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return error;
  }

  const str = value.trim();

  // Matches: "YYYY" or "YYYY[-–/](YY|YYYY)"
  const m = str.match(/^(\d{4})(?:\s*[-–/]\s*(\d{2}|\d{4}))?\s*$/);
  if (!m) {
    return error;
  }

  const start = Number(m[1]);
  if (!Number.isInteger(start)) {
    return error;
  }

  // Reasonable bounds (adjust if your domain needs different limits)
  const MIN_YEAR = 1900;
  const MAX_YEAR = 2100;

  if (start < MIN_YEAR || start > MAX_YEAR) {
    return error;
  }

  // Single year is valid
  if (!m[2]) {
    return { valid: true };
  }

  // Range provided; normalize end year
  const endRaw = m[2];
  let end: number;

  if (endRaw.length === 2) {
    // Expand shorthand YY relative to start century
    const startCentury = Math.floor(start / 100) * 100;
    end = startCentury + Number(endRaw);
    if (end < start) {
      end += 100; // handle wrap like 1999-00 => 2000
    }
  } else {
    end = Number(endRaw);
  }

  if (!Number.isInteger(end) || end < MIN_YEAR || end > MAX_YEAR) {
    return error;
  }

  // Enforce adjacent tax year (e.g., 2024-2025)
  if (end !== start + 1) {
    return error;
  }

  return { valid: true };
}

export function validatePeriod(value: any): { valid: boolean; message?: string } {
  const error = {
    valid: false,
    message: "Please enter a valid period as a non-negative integer or range like '12-24'."
  };

  // Treat undefined/null/empty string as "no value" (valid)
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  if (typeof value !== 'string') {
    return error;
  }

  const str = value.trim();

  // Match: "NNN" or "NNN[-–]NNN" (non-negative integers)
  const m = str.match(/^(\d+)(?:\s*[-–]\s*(\d+))?$/);
  if (!m) {
    return error;
  }

  const start = Number(m[1]);
  const end = m[2] !== undefined ? Number(m[2]) : undefined;

  // Basic sanity bounds (adjust as needed for your domain)
  const MIN = 0;
  const MAX = 10000;

  // Start checks
  if (!Number.isInteger(start) || start < MIN || start > MAX) {
    return error;
  }

  // If range provided, validate end and ordering
  if (end !== undefined) {
    if (!Number.isInteger(end) || end < MIN || end > MAX) {
      return error;
    }
    if (end < start) {
      return error;
    }
  }

  return { valid: true };
}
export function validateNegativeMillionToPositiveBillionCurrency(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const validCurrency = validateCurrency(value);
  if (!validCurrency.valid) { return validCurrency; }
  
  const validNumber = toNumber(value);
  if (typeof validNumber === 'number' && rangeValidation(validNumber, -1000000, 1000000000) ){
    return { valid: false,  message: 'Please enter a valid currency amount.' };
  }

  return { valid: true };
}
export function validatePositiveHundredKCurrencyIncludeZero(value: any): { valid: boolean; message?: string } {   
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const validCurrency = validateCurrency(value);
  if (!validCurrency.valid) { return validCurrency; }
  
  const validNumber = toNumber(value);
  if (typeof validNumber === 'number' && rangeValidation(validNumber, 0, 100000) ){
    return { valid: false,  message: 'Please enter a valid currency amount.' };
  }

  return { valid: true };
}

export function validatePositiveBillionCurrencyIncludeZero(value: any): { valid: boolean; message?: string } {
  const err = { valid: false,  message: 'Invalid entry. The value must be greater than zero.' };
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  // Accounting-style negative currency, e.g. (3,345) or ($3,345), must be invalid.
  if (typeof value === 'string' && /^\s*\(.*\)\s*$/.test(value.trim())) {
    return err;
  }
  
  const validCurrency = validateCurrency(value);
  if (!validCurrency.valid) { return err; }
  
  const validNumber = toNumber(value);
  if (typeof validNumber === 'number' && rangeValidation(validNumber, 0, 1000000000) ){
    return err;
  }

  return { valid: true };
}
export function validatePositiveTwentyBillionCurrency(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const err = { valid: false,  message: 'Invalid entry. The value must be greater than zero.' };
  const validCurrency = validateCurrency(value);
  if (!validCurrency.valid) { return err; }
  
  const validNumber = toNumber(value);
  if (typeof validNumber === 'number' && rangeValidation(validNumber, 1, 20000000000) ){
    return err;
  }

  return { valid: true };
}

export function validateDateByFormatMMDDYYYY(value: any ): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const minYear = 1800;
  const maxYear = 2100;
  const failedMessage = { valid: false, message: 'Please enter a valid date (MM/DD/YYYY).' }
 
  const date = new Date(value);
  if (!(value && !isNaN(date.getTime())))
    return failedMessage;

  const parts = value.split('/');
  if (parts.length !== 3) return failedMessage;
  
  if (date.getFullYear() < minYear || date.getFullYear() > maxYear) return failedMessage;   

  return { valid: true };
}

export function validateDateByFormatMMDDYYYYSince1900UptoCurrentDate(value: any): { valid: boolean; message?: string } {
  
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }

  const validDateSince1900 = validateDateByFormatMMDDYYYYSince1900(value);
  if (!validDateSince1900.valid) { return validDateSince1900; } 

  const [month, day, year] = value.split('/').map(Number);
  const date = new Date(year, month - 1, day);

  // Validate date boundaries  
  const maxDate = new Date(); // today
  
  if (date > maxDate) {
    return { valid: false, message: 'The date must be no later than today.' };
  }

  return { valid: true };
}

export function validateDateByFormatMMDDYYYYSince1900(value: any ): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
 const failedMessage = { valid: false, message: 'If provided, value must be in MM/DD/YYYY and later than 2000.' }
  const parts = value.split('/');
  if (parts.length !== 3) return failedMessage;

  const month = Number(parts[0]);
  const day = Number(parts[1]);
  const year = Number(parts[2]);

  if (year < 1900) return failedMessage;

  const date = new Date(year, month - 1, day);

  const valid = (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
  
  if (!valid) return failedMessage;

  return { valid: true };
}
export function validateNotRequiredIntegers(value: any): { valid: boolean; message?: string } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
        return { valid: true };
      } else {
        return validateIntegers(value);
      }
}


export function validateIntegers(value: any): { valid: boolean; message?: string } {
  if (/^-?\d+$/.test(value)) {
  return {valid:true};
  } else {
  return {valid:false, message: 'Please enter a valid integer(s).'};
  }
}

const requiredValidation = (value: any | null | undefined): { valid: boolean; message?: string } => {
      if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
        return { valid: false,  message: 'This is required field' };
      } else {
        return { valid: true };
      }
    };

const rangeValidation = (value: number, min: number, max: number): boolean => {
      return value < min || value > max;
    };

const toNumber = (value: any | null | undefined): number | string => {
      if (typeof value === 'string' && value !== '-' && value !== '.' && value !== '') {
        return Number(value.trim().replace(/[^0-9.-]+/g, ''));
      } else if (typeof value === 'number') {
        return value;
      }
      else {
        return '';
      }
    };



function validateLatitude(value: any, lookupValues?: { [key: string]: string[]; } | undefined): { valid: boolean; message?: string | undefined; } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const err = { valid: false, message: "Please enter a valid latitude in the format '73.985428' (up to six decimal places)." };
  const normalized = typeof value === 'number' ? value : Number(String(value).trim());

  if (!Number.isFinite(normalized)) {
    return err;
  }

  if (normalized < -90 || normalized > 90) {
    return err;
  }

  return { valid: true };
}

function validateLongitude(value: any, lookupValues?: { [key: string]: string[]; } | undefined): { valid: boolean; message?: string | undefined; } {
  if (value === undefined || value === null || (typeof value === 'string' && value.trim() === '')) {
    return { valid: true };
  }
  const err = { valid: false, message: "Please enter a valid longitude in the format '73.985428' (up to six decimal places)." };
  const normalized = typeof value === 'number' ? value : Number(String(value).trim());

  if (!Number.isFinite(normalized)) {
    return err;
  }

  if (normalized < -180 || normalized > 180) {
    return err;
  }

  return { valid: true };
}

